/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShopForMeItem } from './ShopForMeItem';
import {
  ShopForMeItemFromJSON,
  ShopForMeItemFromJSONTyped,
  ShopForMeItemToJSON,
} from './ShopForMeItem';
import type { CourierUser } from './CourierUser';
import {
  CourierUserFromJSON,
  CourierUserFromJSONTyped,
  CourierUserToJSON,
} from './CourierUser';
import type { CourierPackage } from './CourierPackage';
import {
  CourierPackageFromJSON,
  CourierPackageToJSON,
} from './CourierPackage';

/**
 *
 * @export
 * @interface ShopForMeRequest
 */
export interface ShopForMeRequest {
  /**
   *
   * @type {number}
   * @memberof ShopForMeRequest
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof ShopForMeRequest
   */
  courierId?: number;
  /**
   *
   * @type {number}
   * @memberof ShopForMeRequest
   */
  customerId?: number;
  /**
   *
   * @type {string}
   * @memberof ShopForMeRequest
   */
  status?: string;
  /**
   *
   * @type {number}
   * @memberof ShopForMeRequest
   */
  totalAmount?: number;
  /**
   *
   * @type {number}
   * @memberof ShopForMeRequest
   */
  purchasingFee?: number;
  /**
   *
   * @type {number}
   * @memberof ShopForMeRequest
   */
  grandTotal?: number;
  /**
   *
   * @type {string}
   * @memberof ShopForMeRequest
   */
  currency?: string;
  /**
   *
   * @type {string}
   * @memberof ShopForMeRequest
   */
  notes?: string;
  /**
   *
   * @type {string}
   * @memberof ShopForMeRequest
   */
  adminNotes?: string;
  /**
   *
   * @type {string}
   * @memberof ShopForMeRequest
   */
  paymentMethod?: string;
  /**
   *
   * @type {string}
   * @memberof ShopForMeRequest
   */
  paymentStatus?: string;
  /**
   *
   * @type {string}
   * @memberof ShopForMeRequest
   */
  paymentReference?: string;
  /**
   *
   * @type {string}
   * @memberof ShopForMeRequest
   */
  proofOfPayment?: string;
  /**
   *
   * @type {Date}
   * @memberof ShopForMeRequest
   */
  quoteExpiresAt?: Date;
  /**
   *
   * @type {Date}
   * @memberof ShopForMeRequest
   */
  quotedAt?: Date;
  /**
   *
   * @type {Date}
   * @memberof ShopForMeRequest
   */
  confirmedAt?: Date;
  /**
   *
   * @type {Date}
   * @memberof ShopForMeRequest
   */
  paidAt?: Date;
  /**
   *
   * @type {number}
   * @memberof ShopForMeRequest
   */
  packageId?: number;
  /**
   *
   * @type {Date}
   * @memberof ShopForMeRequest
   */
  purchasedAt?: Date;
  /**
   *
   * @type {Date}
   * @memberof ShopForMeRequest
   */
  createdAt?: Date;
  /**
   *
   * @type {Date}
   * @memberof ShopForMeRequest
   */
  updatedAt?: Date;
  /**
   *
   * @type {Array<ShopForMeItem>}
   * @memberof ShopForMeRequest
   */
  items?: Array<ShopForMeItem>;
  /**
   *
   * @type {CourierUser}
   * @memberof ShopForMeRequest
   */
  courierUser?: CourierUser;
  /**
   * Customer relation (alias for courierUser)
   * @type {any}
   * @memberof ShopForMeRequest
   */
  customer?: any;
  /**
   * Linked package for tracking
   * @type {CourierPackage}
   * @memberof ShopForMeRequest
   */
  linkedPackage?: CourierPackage;
}

/**
 * Check if a given object implements the ShopForMeRequest interface.
 */
export function instanceOfShopForMeRequest(
  value: object
): value is ShopForMeRequest {
  return true;
}

export function ShopForMeRequestFromJSON(json: any): ShopForMeRequest {
  return ShopForMeRequestFromJSONTyped(json, false);
}

export function ShopForMeRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ShopForMeRequest {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'] == null ? undefined : json['id'],
    courierId: json['courierId'] == null ? undefined : json['courierId'],
    customerId: json['customerId'] == null ? undefined : json['customerId'],
    status: json['status'] == null ? undefined : json['status'],
    totalAmount: json['totalAmount'] == null ? undefined : json['totalAmount'],
    purchasingFee: json['purchasingFee'] == null ? undefined : json['purchasingFee'],
    grandTotal: json['grandTotal'] == null ? undefined : json['grandTotal'],
    currency: json['currency'] == null ? undefined : json['currency'],
    notes: json['notes'] == null ? undefined : json['notes'],
    adminNotes: json['adminNotes'] == null ? undefined : json['adminNotes'],
    paymentMethod: json['paymentMethod'] == null ? undefined : json['paymentMethod'],
    paymentStatus: json['paymentStatus'] == null ? undefined : json['paymentStatus'],
    paymentReference: json['paymentReference'] == null ? undefined : json['paymentReference'],
    proofOfPayment: json['proofOfPayment'] == null ? undefined : json['proofOfPayment'],
    quoteExpiresAt: json['quoteExpiresAt'] == null ? undefined : new Date(json['quoteExpiresAt']),
    quotedAt: json['quotedAt'] == null ? undefined : new Date(json['quotedAt']),
    confirmedAt: json['confirmedAt'] == null ? undefined : new Date(json['confirmedAt']),
    packageId: json['packageId'] == null ? undefined : json['packageId'],
    paidAt: json['paidAt'] == null ? undefined : new Date(json['paidAt']),
    purchasedAt: json['purchasedAt'] == null ? undefined : new Date(json['purchasedAt']),
    createdAt: json['createdAt'] == null ? undefined : new Date(json['createdAt']),
    updatedAt: json['updatedAt'] == null ? undefined : new Date(json['updatedAt']),
    items: json['items'] == null ? undefined : (json['items'] as Array<any>).map(ShopForMeItemFromJSON),
    courierUser: json['courierUser'] == null ? undefined : CourierUserFromJSON(json['courierUser']),
    customer: json['customer'] == null ? undefined : json['customer'],
    linkedPackage: json['linkedPackage'] == null ? undefined : CourierPackageFromJSON(json['linkedPackage']),
  };
}

export function ShopForMeRequestToJSON(json: any): ShopForMeRequest {
  return ShopForMeRequestToJSONTyped(json, false);
}

export function ShopForMeRequestToJSONTyped(
  value?: ShopForMeRequest | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value['id'],
    courierId: value['courierId'],
    customerId: value['customerId'],
    status: value['status'],
    totalAmount: value['totalAmount'],
    purchasingFee: value['purchasingFee'],
    grandTotal: value['grandTotal'],
    currency: value['currency'],
    notes: value['notes'],
    adminNotes: value['adminNotes'],
    paymentMethod: value['paymentMethod'],
    paymentStatus: value['paymentStatus'],
    paymentReference: value['paymentReference'],
    proofOfPayment: value['proofOfPayment'],
    quoteExpiresAt: value['quoteExpiresAt'] == null ? undefined : value['quoteExpiresAt'].toISOString(),
    quotedAt: value['quotedAt'] == null ? undefined : value['quotedAt'].toISOString(),
    confirmedAt: value['confirmedAt'] == null ? undefined : value['confirmedAt'].toISOString(),
    packageId: value['packageId'],
    paidAt: value['paidAt'] == null ? undefined : value['paidAt'].toISOString(),
    purchasedAt: value['purchasedAt'] == null ? undefined : value['purchasedAt'].toISOString(),
    createdAt: value['createdAt'] == null ? undefined : value['createdAt'].toISOString(),
    updatedAt: value['updatedAt'] == null ? undefined : value['updatedAt'].toISOString(),
    items: value['items'] == null ? undefined : (value['items'] as Array<any>).map(ShopForMeItemToJSON),
    courierUser: CourierUserToJSON(value['courierUser']),
    customer: value['customer'],
    linkedPackage: value['linkedPackage'] == null ? undefined : CourierPackageToJSON(value['linkedPackage']),
  };
}
